import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Container } from 'reactstrap';
// import Breadcrumbs from 'react-router-breadcrumbs'
// import { routes } from './../../App'
import moment from 'moment'
import autobind from 'react-autobind'
import _ from 'lodash'
import { Link } from 'react-router-dom';

class StatusBar extends Component {

    constructor(props) {
        super(props)
        autobind(this)
    }

    isExpired(expirationDate) {
        const currentDate = new Date();
        const expireDate = new Date(expirationDate)
        const isExpired = currentDate.getTime() > expireDate.getTime()

        return isExpired
    }

    expiresIn(expirationDate) {
        const oneDay = 24 * 60 * 60 * 1000;
        const currentDate = new Date();
        const expireDate = new Date(expirationDate)

        return Math.round(Math.abs(expireDate.getTime() - currentDate.getTime()) / (oneDay))
    }

    expiredAt(expirationDate) {
        let todayDate = new Date();
        let todayDateMoment = moment(todayDate);
        let expiresDateMoment = moment(expirationDate);

        return expiresDateMoment.diff(todayDateMoment, 'days')
    }

    getSeverityClassName(severity) {

        if (severity >= 999) {
            return 'danger'
        }

        if (severity > 0) {
            return 'warning'
        }

        return ''

    }

    render() {

        const { subscriptions } = this.props;

        const expiresText = _.map(subscriptions, s => s.message).filter(Boolean)
            , severity = _.map(subscriptions, s => s.severity).reduce((acc, s) => acc + s, 0)


        //const showStatusBar = isOneDemo || severity > 0;
        const showStatusBar = false;
        return showStatusBar ? (
            <div className={'mai-sub-header status-bar d-flex align-items-center ' + this.getSeverityClassName(severity)}>
                <Container className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        <span className="s7-info icon"></span>
                        <div className="d-flex flex-column align-items-start justify-content-center">
                            {expiresText.map((t, index) => (
                                <div className="mb-0 pr-4" key={"substatus" + index}>{t}</div>
                            ))}
                        </div>
                    </div>
                    <Link to="/my-account" className="btn btn-rounded btn-md-lateral-space btn-space btn-secondary">Upgrade</Link>
                </Container>
            </div>
        ) : null;
    }
}

export default connect(
    (state, ownProps) => {
        const { userStatus: { active, subscriptions } } = state
        return { active, subscriptions }
    },
    (stateProps, dispatchProps) => {
        return Object.assign({}, stateProps, dispatchProps)
    }
)(StatusBar)



// WEBPACK FOOTER //
// ./src/components/Status/StatusBar.js